import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installFetchAuthRefresh } from './utilities';

installFetchAuthRefresh();

ReactDOM.render(<App />, document.getElementById('root'));

reportWebVitals();
